import { TagProps } from './index';

export const TAG_VARIANTS = {
  IN_PROGRESS: {
    text: 'In Progress',
    backgroundColor: '#191F2E14',
    textColor: 'default'
  } as Partial<TagProps>,

  BY_OTHER: {
    text: 'By Other',
    backgroundColor: '#191F2E14',
    textColor: 'default'
  } as Partial<TagProps>,

  REQUEST_GROUP: {
    text: 'Request Group',
    backgroundColor: '#191F2E14',
    textColor: 'default'
  } as Partial<TagProps>,

  BULK: {
    text: 'Massive',
    backgroundColor: '#191F2E14',
    textColor: 'default',
    size: 'compact'
  } as Partial<TagProps>,

  SUCCESS: {
    backgroundColor: '#44AC2114',
    textColor: '#44AC21'
  } as Partial<TagProps>,

  ERROR: {
    backgroundColor: '#FF323614',
    textColor: '#FF3236'
  } as Partial<TagProps>,

  WARNING: {
    backgroundColor: '#FFA50014',
    textColor: '#FFA500'
  } as Partial<TagProps>,

  INFO: {
    backgroundColor: '#3B82F614',
    textColor: '#3B82F6'
  } as Partial<TagProps>,

  REASSIGNED: {
    text: 'Reassigned',
    backgroundColor: '#191F2E14',
    textColor: 'default',
    size: 'compact',
    iconSize: 'md'
  } as Partial<TagProps>,

  SKIPPED: {
    text: 'Skipped',
    backgroundColor: '#191F2E14',
    textColor: 'default',
    size: 'compact',
    iconSize: 'md'
  } as Partial<TagProps>
} as const;

export type TagVariant = keyof typeof TAG_VARIANTS;
